import getGiInfo from "./getGiInfo";

/**
 * Fetches GI screenshot data, delegating to {@link getGiInfo}.
 *
 * @param giInfoPath - Firestore path variant ("api" or default). Read from Redux
 *   at the call site and passed in to avoid hook usage outside components.
 */
export const fetchGiData = async (
  giInfoPath?: string,
): Promise<{
  versions: any;
  total_unique_orders_stored: number;
}> => {
  try {
    const giInfo = await getGiInfo(giInfoPath);
    return giInfo;
  } catch (error) {
    console.error("Error fetching GI data:", error);
    throw error;
  }
};
